import styled, { keyframes } from 'styled-components';

const rotate = keyframes`
    to {
        transform: rotate(360deg);
    }
`;

export const StyledSpinner = styled.svg`
    display: block;
    flex-shrink: 0;
    animation: ${rotate} 1s linear infinite;
    will-change: transform;

    .spinner-from {
        stop-color: var(--primary-color-bleached);
    }

    .spinner-to {
        stop-color: var(--primary-color);
    }

    .spinner-arc {
        fill: none;
        stroke-width: 8;
        stroke-linecap: round;
        stroke-dasharray: 160 216.77;
    }
`;
